import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { listGalleryImages } from "@/lib/gallery-api";
import { Reveal } from "@/components/Reveal";
import { GALLERY } from "@/constants/testIds";

// Public gallery grid + click-to-enlarge lightbox. Content is entirely
// GM-managed (see components/gallery/GalleryAdminPage.jsx) - this component
// only reads and displays.
export const Gallery = () => {
  const [images, setImages] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    listGalleryImages()
      .then(setImages)
      .catch(() => setImages([]));
  }, []);

  if (images === null) {
    return <p className="text-center text-sm text-white/40">Načítám galerii…</p>;
  }

  if (images.length === 0) {
    return (
      <p className="text-center text-sm text-white/40" data-testid={GALLERY.empty}>
        Galerie je zatím prázdná - první snímky brzy přibudou.
      </p>
    );
  }

  return (
    <>
      <div
        className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4"
        data-testid={GALLERY.grid}
      >
        {images.map((img, i) => (
          <Reveal key={img.id} delay={Math.min(i * 0.04, 0.4)}>
            <button
              type="button"
              onClick={() => setActive(img)}
              data-testid={GALLERY.image}
              className="group block aspect-square w-full overflow-hidden rounded-lg border border-white/10"
            >
              <img
                src={img.image_url}
                alt={img.caption || "Draconia RP"}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </button>
          </Reveal>
        ))}
      </div>

      <Dialog open={Boolean(active)} onOpenChange={(open) => !open && setActive(null)}>
        <DialogContent
          data-testid={GALLERY.lightbox}
          className="border-white/10 bg-[#0A0A0C] p-2 sm:max-w-3xl"
        >
          {active && (
            <div>
              <img src={active.image_url} alt={active.caption || "Draconia RP"} className="w-full rounded-md" />
              {active.caption && <p className="mt-3 px-2 pb-1 text-center text-sm text-white/60">{active.caption}</p>}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
